import axiosDmsInstance from './axiosDmsInstance';
import { encodeInvalidCharacters, handleApiError } from '../../common/util';
import { IFixedAssetDetails } from '../../models/dms/fixedAsset.model';

export const getFixedAssetDetails = async (unitId: string) => {
  try {
    const url = `/api/account/fixedasset/${encodeInvalidCharacters(unitId)}/v1/detail`;
    let params = {} as any;

    const response = await axiosDmsInstance.get<IFixedAssetDetails>(`${url}`, {
      params,
    });

    return response.data;
  } catch (err: any) {
    return handleApiError('getFixedAssetDetails', err);
  }
};
